import moment from 'moment';

export function getTimeStamp() {
  return moment().unix();
}

export function getAdmissionMomentDate(dateTimeString) {
  return moment(dateTimeString, 'e-HHmm');
}

export function getHmAMomentDate(momentDate, dateTimeString) {
  const dateStr = `${momentDate.format('YYYY-MM-DD')} ${dateTimeString}`;
  return moment(dateStr, 'YYYY-MM-DD HHmmA');
}

export function venueToCurrentDate(date, endOfNightHour) {
  const prevEndOfNight = getHmAMomentDate(moment(date), endOfNightHour);
  const momentDate = moment(date);
  if (prevEndOfNight.isAfter(momentDate)) {
    return momentDate.add(1, 'day');
  }
  return momentDate;
}

export function currentToVenueDate(date, endOfNightHour) {
  const prevEndOfNight = getHmAMomentDate(moment(date), endOfNightHour);
  const momentDate = moment(date);
  if (prevEndOfNight.isAfter(momentDate)) {
    return momentDate.subtract(1, 'day');
  }
  return momentDate;
}

export function getCurrentDate(
  endOfNightHour,
  dateFormatString = 'YYYY-MM-DD'
) {
  return currentToVenueDate(new Date(), endOfNightHour).format(
    dateFormatString
  );
}

export function getStartOfDay(day) {
  return moment().day(day).startOf('day');
}

export function getEndOfNightMomentDate(momentDate, endOfNightHour) {
  return getHmAMomentDate(momentDate.clone().add(1, 'day'), endOfNightHour);
}

export function getDay(endOfNightHour, formatString) {
  const now = moment();
  const compareDate = getHmAMomentDate(moment(), endOfNightHour);

  let targetDate = now;

  if (endOfNightHour.endsWith('AM') && now.unix() < compareDate.unix()) {
    targetDate = compareDate.clone().subtract(1, 'day');
  }

  if (formatString) {
    return targetDate.format(formatString);
  }
  return targetDate.day();
}

export function getAdmissionScheduleRange(
  dateTimeString,
  endOfNight,
  endOfNightHour
) {
  const currentDay = getDay(endOfNightHour);
  const paramDay = +dateTimeString.substr(0, 1);
  const momentDate = getAdmissionMomentDate(dateTimeString);

  // @NOTE because on Sunday, day=0, and getAdmissionMomentDate calculate as next week
  // we should subtract 1 week
  if (currentDay === paramDay && currentDay === 6 && moment().day() === 0) {
    momentDate.subtract(1, 'week');
  }

  const start = momentDate.unix();
  const end = endOfNight
    ? getEndOfNightMomentDate(momentDate, endOfNightHour).unix()
    : momentDate.endOf('day').unix();

  return { start, end };
}

export function getPromoRange(day, endOfNightHour, startHour, endHour) {
  const momentDate = getStartOfDay(day);
  if (day === 6 && moment().day() === 0) {
    momentDate.subtract(1, 'week');
  }

  const endOfNight = getEndOfNightMomentDate(momentDate, endOfNightHour).unix();

  const start = startHour
    ? getHmAMomentDate(momentDate, startHour).unix()
    : momentDate.unix();
  let end = getEndOfNightMomentDate(
    momentDate,
    endHour || endOfNightHour
  ).unix();

  if (endHour && end > endOfNight) {
    end = getEndOfNightMomentDate(
      momentDate.subtract(1, 'day'),
      endHour
    ).unix();
  }

  return {
    start,
    end,
  };
}
